import React from 'react';
import { Container, Row, Col, Form, Button, Card, CardBody, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import LogoDark from '../images/logo-footer-dark.svg';
import LogoLight from '../images/logo-footer-light.svg';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';

export default function Login() {
    const { theme } = useTheme();
    // navigate
    const navigate = useNavigate();
    const redirectToHome = () => {
        navigate('/home');
    };
    return (
        <>
            <motion.div className="auth-page" initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                <Container>
                    <Row className='justify-content-center'>
                        <Col xl={6}>
                            <Card className='auth-card mb-0'>
                                <CardBody>
                                    <motion.div className="auth-contant" initial={{opacity: 0 , y: -20}} whileInView={{opacity: 1 , y: 0}} transition={{duration: 0.5}}>
                                        <div className='auth-logo mb-4'>
                                            <Image src={theme === 'light' ? LogoDark : LogoLight} alt='' height={80} className='' />
                                        </div>
                                        <div className='text-center mb-4'>
                                            <h3 className='fw-semibold'>Welcome to Reshto</h3>
                                            <p className='text-muted mx-lg-5'>Welcome back! Please log in to order your favorite meals & enjoy delicious food delivered to your doorstep.</p>
                                        </div>
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='login-email'>Email address</Form.Label>
                                                <div className="position-relative input-right-icon">
                                                    <i className="ri-mail-line fs-22 text-muted"></i>
                                                    <Form.Control type="email" size="lg" placeholder="Enter your email..." required id='login-email' />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='login-password'>Password</Form.Label>
                                                <div className="position-relative input-right-icon">
                                                    <i className="ri-door-lock-line fs-22 text-muted"></i>
                                                    <Form.Control type="password" size="lg" placeholder="Password" required id='login-password' />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="d-flex align-items-center justify-content-between mb-3">
                                                <Form.Check required id="login-remember" label="Remember me" />
                                                <Link href="#/" className='text-muted text-end text-decoration-underline'>Forgot your password?</Link>
                                            </Form.Group>
                                            <Button onClick={redirectToHome} variant='danger' className="w-100">Login</Button>
                                        </Form>

                                        <p className='auth-or-text text-muted text-center my-4'>or</p>
                                        <div className="d-flex flex-wrap gap-16 justify-content-center">
                                            <Button variant='soft-danger' className='rounded-pill'>
                                                <i className="ri-google-fill"></i> <span className='ms-2'>Login with google</span>
                                            </Button>
                                            <Button variant='soft-primary' className='rounded-pill'>
                                                <i className="ri-facebook-fill"></i> <span className='ms-2'>Login with facebook</span>
                                            </Button>
                                        </div>
                                    </motion.div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </motion.div>
        </>
    )
}
